import React from 'react';
import { useSelector } from 'react-redux';

import { ROUTES } from '~constants/routes';
import { INCUMBENT_TYPES } from '~constants/incumbent';
import SimulationLoadingWrapper from '~app/components/SimulationLoadingWrapper';
import { SIMULATION_TARGETS } from '~redux/Simulation/constants';
import SocioeconomicInformation from '~app/components/SocioeconomicInformation';

function ClientBirthInformation() {
  const { currentClient, clientFinancialInfo, loanDraftLoading } = useSelector(state => state.simulation);
  return (
    <SimulationLoadingWrapper loading={loanDraftLoading}>
      <SocioeconomicInformation
        loading={loanDraftLoading}
        incumbent={INCUMBENT_TYPES.CLIENT}
        birthInfo={currentClient}
        laborInfo={clientFinancialInfo}
        currentTarget={SIMULATION_TARGETS.CURRENT_CLIENT}
        nextStep={ROUTES.CREDIT_SIMULATION.stepName}
      />
    </SimulationLoadingWrapper>
  );
}

export default ClientBirthInformation;
